import { useThemeUI } from 'theme-ui'
import { path } from '@uswitch/ev-utils/obj'
import { useMeta } from '@uswitch/ev-utils/context/selectors'

const Icon = ({ name, className, size = 'md' }) => {
  const iconsPath = useMeta('iconsPath', '/icons.svg')
  const { theme } = useThemeUI()
  const s = path(['sizes', 'icon', size], theme) || 32

  return (
    <svg viewBox={`0 0 ${s} ${s}`} width={s} height={s} className={className}>
      <use xlinkHref={`${iconsPath}#icon-${name}`} />
    </svg>
  )
}

export default Icon
